import {Action} from '@ngrx/store';

import {ImpersonateUser} from '../models/impersonate-user';
import {Role} from '../models/role';
import {type} from '../utilities/type';

export const userContextActionTypes = {
  LOAD_ROLES: type('[User Context] Load Roles'),
  LOAD_ROLES_SUCCESS: type('[User Context] Load Roles Success'),
  LOAD_ROLES_FAIL: type('[User Context] Load Roles Fail'),
  CHANGE_CLIENT: type('[User Context] Change Client'),
  CHANGE_SITE: type('[User Context] Change SITE'),
  CHANGE_SUBSCRIPTION: type('[User Context] Change SubscriptionI'),
  START_IMPERSONATION: type('[User Context] Start Impersonation'),
  START_IMPERSONATION_SUCCESS: type('[User Context] Start Impersonation Success'),
  START_IMPERSONATION_FAIL: type('[User Context] Start Impersonation Server Error'),
  STOP_IMPERSONATION: type('[User Context] Stop Impersonation'),
  CLEAR_IMPERSONATION: type('[User Context] Clear Impersonation'),
  SELECT_ITEM: type('[User Context] Select item'),
  CLEAR_SELECT_ITEM: type('[User Context] Clear select item')
};

export class LoadRolesAction implements Action {
  readonly type = userContextActionTypes.LOAD_ROLES;
  constructor(public payload?: string) {}
}

export class LoadRolesSuccessAction implements Action {
  readonly type = userContextActionTypes.LOAD_ROLES_SUCCESS;
  constructor(public payload?: Role[]) {}
}

export class LoadRolesServerErrorAction implements Action {
  readonly type = userContextActionTypes.LOAD_ROLES_FAIL;
  constructor(public payload?: string) {}
}

export class ChangeSiteAction implements Action {
  readonly type = userContextActionTypes.CHANGE_SITE;
  constructor(public payload?: string) {}
}

export class ChangeSubscriptionAction implements Action {
  readonly type = userContextActionTypes.CHANGE_SUBSCRIPTION;
  constructor(public payload?: string) {}
}

export class ChangeClientAction implements Action {
  readonly type = userContextActionTypes.CHANGE_CLIENT;
  constructor(public payload?: { clientId: string; redirect: boolean }) {}
}

export class StartImpersonationAction implements Action {
  readonly type = userContextActionTypes.START_IMPERSONATION;
  constructor(public payload?: ImpersonateUser) {}
}

export class StartImpersonationSuccessAction implements Action {
  readonly type = userContextActionTypes.START_IMPERSONATION_SUCCESS;
  constructor(public payload?: ImpersonateUser) {}
}

export class StartImpersonationServerErrorAction implements Action {
  readonly type = userContextActionTypes.START_IMPERSONATION_FAIL;
  constructor(public payload?: string) {}
}

export class StopImpersonationAction implements Action {
  readonly type = userContextActionTypes.STOP_IMPERSONATION;
  constructor() {}
}

export class ClearImpersonationAction implements Action {
  readonly type = userContextActionTypes.CLEAR_IMPERSONATION;
  constructor() {}
}

export class SelectItemAction implements Action {
  readonly type = userContextActionTypes.SELECT_ITEM;
  constructor(public payload?: string) {}
}

export class ClearSelectItemAction implements Action {
  readonly type = userContextActionTypes.CLEAR_SELECT_ITEM;
  constructor() {}
}
